<template>
  <div>
    <div class="tf-amtbox">
      <span class="tf-sym">{{ sym }}</span>
      <input
        :value="modelValue"
        type="number"
        inputmode="decimal"
        :placeholder="t('me.tfAmtPlaceholder')"
        @input="onInput"
      />
    </div>
    <div class="tf-pcts">
      <button type="button" @click="emit('pct', 25)">25%</button>
      <button type="button" @click="emit('pct', 50)">50%</button>
      <button type="button" @click="emit('pct', 100)">
        {{ t('me.tfAll') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string
  sym: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
  pct: [pct: number]
}>()

const { t } = useI18n()

const onInput = (e: Event) => {
  const raw = (e.target as HTMLInputElement).value
  // 仅保留数字与一个小数点。最多 6 位，与 1 元 = 1000000 一致；1.005 这类结果原样保留
  let v = raw.replace(/[^\d.]/g, '')
  const parts = v.split('.')
  if (parts.length > 2) v = `${parts[0]}.${parts.slice(1).join('')}`
  const [intPart = '', decPart] = v.split('.')
  if (decPart !== undefined) v = `${intPart}.${decPart.slice(0, 6)}`
  emit('update:modelValue', v)
}
</script>

<style scoped lang="scss">
.tf-amtbox {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--surface);
  border: 1px solid var(--hairline);
  border-radius: var(--r-md);
  padding: 12px 14px;

  .tf-sym {
    font-weight: 800;
    color: var(--gold-hi, #ffd274);
  }

  input {
    flex: 1;
    background: none;
    border: 0;
    outline: 0;
    color: var(--text);
    font-size: 18px;
    font-weight: 700;
    min-width: 0;

    &::placeholder {
      color: var(--muted);
      font-weight: 600;
      font-size: 15px;
    }
  }
}

.tf-pcts {
  display: flex;
  gap: 8px;
  margin-top: 10px;

  button {
    flex: 1;
    padding: 8px;
    border-radius: 999px;
    background: var(--surface);
    border: 1px solid var(--hairline);
    color: var(--muted);
    font-size: 12px;
    font-weight: 700;

    &:active {
      border-color: var(--primary);
      color: var(--text);
    }
  }
}
</style>
